export const getAccumulatedInitialState = {
	accumulated: null,
	error: null,
	errorShow: false,
	loading: false,
};
